import * as TabsPrimitive from "@radix-ui/react-tabs";
import * as React from "react";

import { cn } from "@/shared/utils";
import { createDataTestidFromChildren } from "@/shared/utils/data-testid";

function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
    return <TabsPrimitive.Root data-slot="tabs" className={cn("flex flex-col gap-2", className)} {...props} />;
}

function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
    return <TabsPrimitive.List data-slot="tabs-list" className={cn("flex h-12 items-center gap-6 border-b", className)} {...props} />;
}

function TabsTrigger({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
    return (
        <TabsPrimitive.Trigger
            data-slot="tabs-trigger"
            data-testid={createDataTestidFromChildren(props.children, "tabs-trigger")}
            className={cn(
                "data-[state=active]:text-content-selected text-muted text-m hover:text-content-selected data-[state=active]:border-selected-default relative -bottom-[1px] flex h-[calc(100%-1px)] items-center justify-center gap-1.5 border-b-2 border-transparent font-normal whitespace-nowrap transition-[color,box-shadow] hover:cursor-pointer disabled:pointer-events-none disabled:opacity-50 data-[state=active]:font-bold [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
                className
            )}
            {...props}
        />
    );
}

function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
    return <TabsPrimitive.Content data-slot="tabs-content" className={cn("flex-1 outline-none", className)} {...props} />;
}

export { Tabs, TabsContent, TabsList, TabsTrigger };
